import { FieldCarbonTable as CarbonInfoTable } from '@/components/tables/carbon-info-table.component';
import { FieldBasicInfoTablesWeb } from '@/components/tables/field-basic-info-tables.component';
import { H3 } from '@/components/typography/heading/headings.component';
import { cn } from '@/lib/utils';
import clsx from 'clsx';

export type FieldData = {
  fieldInfo: {
    generalInfo: {
      customerName: string;
      customerId: string;
      projectName: string;
      projectId: string;
      farmId: string;
      farmName: string;
      fieldNumber: string;
      fieldName: string;
      fieldId: string;
      fieldIndex: string;
      fieldDescription: string;
    };
    terrainInfo: {
      measuredFieldAreaHa: number;
      terrainType: string;
      landUse: string;
    };
  };
  carbonInfo: {
    totalCarbonStock: number;
    averageCarbonPerHectare: number;
    carbonStdDeviation: number;
    comparisonToFarm: string;
    coreCount: number;
  };
  breadcrumb: {
    client: {
      id: string;
      name: string;
    };
    project: {
      id: string;
      name: string;
    };
    farm: {
      id: string;
      name: string;
    };
  };
};

export type FieldCarbonTableProps = {
  fieldData: FieldData;
  className?: string;
};

export const FieldCarbonTable = ({ className, fieldData }: FieldCarbonTableProps) => {
  if (!fieldData) return;
  return (
    <div className={clsx(className)}>
      <div className={cn('flex-col gap-3')}>
        <H3>Field Carbon Information</H3>
        <FieldBasicInfoTablesWeb data={fieldData} />
      </div>
      <CarbonInfoTable data={fieldData} isField={true} className={className} />
    </div>
  );
};
